/* Create type */
import {PartFeaturesTableConfig} from './detailview-config.model';

export class DetailFormDataModel {
  // Global property
  public selectedFeature: any;
  public selectedFeatureFields: any;
  public featureIsEditable: boolean;
  public configFormFields: any;
  public partFeaturesTableConfig: PartFeaturesTableConfig;
  public detailViewAttributeTitle: string;
  public isCreateMode: boolean;
  private _detailViewTitle: string;
  public formColumns: number;

  /* SETTER & GETTER
  ====================  */

  public setDetailViewAttributeTitle(attributeField: any) {
    this.detailViewAttributeTitle = attributeField;
  }

  public set detailViewTitle(title: string) {
    this._detailViewTitle = title;
  }

  public setConfigFormFields(config: any) {
    this.configFormFields = config;
  }

  public setPartFeaturesTableConfig(config: PartFeaturesTableConfig) {
    this.partFeaturesTableConfig = config;
  }

  public setFeatureIsEditable(isEditable: boolean, feature) {
    if (feature.attributes['VERKAUFT'] === 1) {
      this.featureIsEditable = false;
      return;
    }
    this.featureIsEditable = isEditable;
  }

  public setSelectedFeature(graphicFeature) {
    this.selectedFeature = graphicFeature;
  }

  public setIsCreateMode(isCreateMode: boolean) {
    this.isCreateMode = isCreateMode;
  }

  public setSelectedFeatureFields(fields) {
    this.selectedFeatureFields = fields;
  }

  public get detailViewTitle(): string {
    return this._detailViewTitle;
  }

}
